import React from 'react'
function WriteLog(message, value) {

    if(process.env.REACT_APP_SHOW_CONSOLE_LOG == 1)
        console.log(message, value);
}
export default WriteLog